import SuiBox from "components/SuiBox";
import Alert from "custom/Alert";
import DashboardLayout from "custom/LayoutContainers/DashboardLayout";
import DashboardNavbar from "custom/Navbars/DashboardNavbar";
import PropTypes from "prop-types";
import { useEffect } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

import ClassDetails from "../components/class-details";

const EditClass = ({ selectedClass, redirectTo }) => {
  const history = useHistory();

  useEffect(() => {
    if (redirectTo && redirectTo !== "" && redirectTo !== "/class/edit") {
      history.push(redirectTo);
    }
  }, [redirectTo]);

  return (
    <>
      <Alert />
      <DashboardLayout>
        <DashboardNavbar />
        <SuiBox mt={3} mb={8}>
          <ClassDetails classData={selectedClass} />
        </SuiBox>
      </DashboardLayout>
    </>
  );
};

EditClass.defaultProps = {
  selectedClass: null,
  redirectTo: "",
};

EditClass.propTypes = {
  selectedClass: PropTypes.objectOf(PropTypes.any),
  redirectTo: PropTypes.string,
};

const mapStateToProps = (state, { location }) => {
  const targetId = location.state?.classId;
  const allClasses = Array.isArray(state?.data?.classes) ? state.data.classes : [];
  const foundClass = allClasses.find((c) => c.id === targetId);

  return {
    selectedClass: foundClass,
    redirectTo: state.ui.redirectTo,
  };
};

export default connect(mapStateToProps, null)(EditClass);
